import { render, staticRenderFns } from "./AdminNewsletter.vue?vue&type=template&id=25dcdda6&scoped=true"
import script from "./AdminNewsletter.vue?vue&type=script&lang=js"
export * from "./AdminNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcdda6",
  null
  
)

export default component.exports